import { connect } from 'react-redux'
import WorkEntry from './work-entry'
import {
  getWork,
  getWorksState
} from '../../../../../../stores/works/works.selectors'
import { format } from 'date-fns/esm'

const mapStateToProps = (state, { id }) => {
  const work = getWork(state, id)
  const updatingRequest = getWorksState(state).updatingWorkRequests
  return {
    pending: updatingRequest[id] && updatingRequest[id].pending,
    date: format(work.created_at, 'dd.MM.yyyy'),
    title: work.title || '-',
    link: `/works/${id}`,
    published: work.status === 'published',
    ageOrder: work.year_group.order,
    ageTitle: work.year_group.title,
    thumbnail: work.media && work.media[0] && work.media[0].thumb_url,
    independent: work.independent,
    independentInfo: work.independent_description
  }
}

export default connect(
  mapStateToProps,
  null
)(WorkEntry)
